export const periodOf = (year: number, month: number) => `${year}-${String(month).padStart(2, '0')}`;

export const splitPeriod = (period: string) => ({ year: Number(period.slice(0, 4)), month: Number(period.slice(5, 7)) });
